export default __webpack_public_path__ + "static/media/arrow-up.f716b2d1.svg";